import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconMinusSvg } from "./IconMinusSvg.mjs";
const IconMinus = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconMinusSvg, ...svgProps }) });
export {
  IconMinus
};
